<template>
  <section class="topstyle">
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      style="margin: 10px auto 0px 15px"
    ></toolbar>
    <el-select
      id="inputselect"
      v-model="filters.CourseTypeId"
      placeholder="请选择类型"
      style="width: 200px; margin: 0px auto 10px 15px"
      @change="selectGetlist()"
    >
      <el-option
        v-for="(item, index) in coursetypelist"
        :key="index"
        :label="item.Name"
        :value="item.Id"
      ></el-option>
    </el-select>

    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="
        margin: 10px auto 0px 15px;
        width: 1581px;
        border: 1px #eaeaea solid;
      "
      :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }"
      empty-text="暂无数据"
      :row-style="{ height: '50px' }"
      :cell-style="{ padding: '15px 0 15px 0px' }"
    >
      <!-- <el-table-column
        type="selection"
        width="50"
        align="center"
      ></el-table-column> -->
      <el-table-column
        type="index"
        width="60"
        label=" "
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Id"
        label="ID"
        width="60"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="CourseTypeName"
        label="分类"
        width="100"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Name"
        label="标题"
        width="100"
        sortable
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="Status"
        label="是否发布"
        width="150"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          {{ scope.row.Status == 2 ? "已发" : "未发" }}
        </template></el-table-column
      >
      <el-table-column
        prop="Score"
        label="分数"
        width="100"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="BrowseNum"
        label="浏览量"
        width="100"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ListImg"
        label="封面"
        width="100"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <div>
            <el-image
              :src="scope.row.ListImg"
              fit="contain"
              @click.native="Logimg.push(scope.row.ListImg)"
            >
            </el-image>
          </div>
        </template>
        <!-- 图片的显示 -->
      </el-table-column>
      <el-table-column prop="IsStick" label="是否置顶" align="center" sortable>
        <template slot-scope="scope">
          <div style="text-align: center">
            {{ scope.row.IsStick === false ? "否" : "是" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        :formatter="formatCreateTime"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.TaskType == 0"
            size="mini"
            type="primary"
            @click="onLookDatas(scope.row.Id)"
            >课程目录</el-button
          >
          <el-tag
            v-if="scope.row.TaskType == 2"
            type="success"
            disable-transitions
            >文章
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px" align="center">
        <template slot-scope="scope">
          <!-- <span class="SpanList" @click="creatQrCode(scope.row.CourseTypeName,scope.row.Id)">查看二维码</span> -->
          <span
            class="SpanList"
            @click="handleEdit(scope.row.Id, scope.row.TaskType)"
            >编辑</span
          >
          <span class="SpanList" @click="handleDel(scope.row.Id)">删除</span>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button
        style="margin-top: 20px"
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      > -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="5"
        :total="total"
        style="text-align: center; margin-top: 100px"
        background
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      @opened="Editwangeditor()"
      custom-class="subTitle"
      :show-close="false"
    >
      <span slot="title">
        <h2>
          编辑
          <span
            @click="DialogDown()"
            style="float: right; width: 100px; font-size: 20px; cursor: pointer"
            >x</span
          >
        </h2>
      </span>
      <el-form
        :model="editForm"
        label-width="90px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="课程标题" prop="Name">
          <el-input v-model="editForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="课程分类">
          <el-select
            v-model="editForm.CourseTypeId"
            placeholder="请选择课程分类"
          >
            <el-option
              v-for="(item, index) in coursetypelist"
              :key="index"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            width="450"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadFile"
          >
            <img
              v-if="editForm.ListImg"
              :src="editForm.ListImg"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="简介" prop="Briefing" v-if="editForm.Istrue">
          <el-input type="textarea" v-model="editForm.Briefing"></el-input>
        </el-form-item>
        <el-form-item label="分数" prop="Stroc">
          <el-input v-model="editForm.Stroc" auto-complete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否置顶" prop="IsStick">
          <el-select v-model="editForm.IsStick" placeholder="请选择状态">
            <el-option
              v-for="(item, index) in Sticklist"
              :label="item.Name"
              :value="item.IsStick"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="是否发布" prop="Status">
          <el-select v-model="editForm.Status" placeholder="请选择状态">
            <el-option
              v-for="(item, index) in Statuslist"
              :label="item.Name"
              :value="item.Status"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!--使用编辑器
        -->
        <el-form-item label="详细" prop="Detail" v-if="!editForm.Istrue">
          <div id="edit_container">
            <!-- <quill-editor
              v-model="editForm.Detail"
              ref="myQuillEditor"
              class="editer"
              :options="editorOption"
              @ready="onEditorReady($event)"
            ></quill-editor> -->
          </div>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      @opened="Addwangeditor()"
      custom-class="subTitle"
      :show-close="false"
    >
      <span slot="title">
        <h2>
          新增
          <span
            @click="DialogDown()"
            style="float: right; width: 100px; font-size: 20px; cursor: pointer"
            >x</span
          >
        </h2>
      </span>
      <el-form
        :model="addForm"
        label-width="90px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="课程标题" prop="Name">
          <el-input v-model="addForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="课程分类">
          <el-select
            v-model="addForm.CourseTypeId"
            placeholder="请选择课程分类"
          >
            <el-option
              v-for="(item, index) in coursetypelist"
              :key="index"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            width="450"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadFile"
          >
            <img v-if="addForm.ListImg" :src="addForm.ListImg" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="简介" prop="Briefing" v-if="addForm.Istrue">
          <el-input type="textarea" v-model="addForm.Briefing"></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否置顶" prop="IsStick">
          <el-select v-model="addForm.IsStick" placeholder="请选择状态">
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="课程或者文章" prop="IsStick">
          <el-select
            v-model="addForm.Istrue"
            placeholder="请选择状态"
            @change="onOptionsyear"
          >
            <el-option label="课程" :value="true"></el-option>
            <el-option label="文章" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分数" prop="Stroc">
          <el-input v-model="addForm.Stroc" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否发布" prop="Status">
          <el-select v-model="addForm.Status" placeholder="请选择状态">
            <el-option label="发布" value="2"></el-option>
            <el-option label="草稿" value="1"></el-option>
          </el-select>
        </el-form-item>
        <!--使用编辑器
        -->
        <el-form-item label="详细" prop="Detail" v-if="addForm.Istrue != true">
          <div class="edit_container" id="Add_container">
            <!-- <quill-editor
              v-model="addForm.Detail"
              ref="myQuillEditor"
              class="editer"
              :options="editorOption"
              @ready="onEditorReady($event)"
            ></quill-editor> -->
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <creatqrcodes
      @closedCodes="closedFnShow"
      :isShowCodes="isShowCodesStatus"
      :Codesvalue="Codesvaluesigin"
      :CodesvalueType="CodesvalueTypeSigin"
    />
  </section>
</template>

<script>
import util from "../../../util/date";
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {
  getcourseListPage,
  getcoursetypes,
  addcourses,
  UploadImg,
  coursedelete,
  getcoursesingle,
  backcourseupdate,
  GetArticlesSingle,
  UpdateArticles,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import E from "wangeditor";
// import QRCode from "qrcodejs2";
import creatqrcodes from "../../components/creatqrcodes";

export default {
  components: { Toolbar, quillEditor, creatqrcodes },
  data() {
    return {
      Codesvaluesigin: "",
      CodesvalueTypeSigin: 0,
      isShowCodesStatus: false,
      //
      editor: null,
      Logimg: [],
      editorOption: {},
      dialogVisible: false,
      formLabelWidth: "80px",
      limitNum: 1,
      buttonList: [],
      coursetypelist: [],
      Sticklist: [
        { Id: 1, Name: "是", IsStick: true },
        { Id: 2, Name: "否", IsStick: false },
      ],
      Statuslist: [
        { Id: 1, Name: "发布", Status: 2 },
        { Id: 2, Name: "草稿", Status: 1 },
      ],
      currentRow: null,
      filters: {
        Title: "",
        CourseTypeId: null,
      },
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入课程标题", trigger: "blur" }],
        CourseTypeId: [
          { required: true, message: "课程类型", trigger: "blur" },
        ],
        Briefing: [{ required: true, message: "简介", trigger: "blur" }],
        Detail: [{ required: true, message: "详情", trigger: "blur" }],
        ListImg: [{ required: true, message: "图片", trigger: "blur" }],

        Status: [{ required: true, message: "未选择", trigger: "blur" }],
        CourseTypeId: [{ required: true, message: "未选择", trigger: "blur" }],
        Stroc: [{ required: true, message: "分数", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        Briefing: "",
        CourseTypeId: null,
        Name: "",
        Detail: "",
        IsStick: false,
        ListImg: "",
        Status: null,
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入课程标题", trigger: "blur" }],
        CourseTypeId: [
          { required: true, message: "课程类型", trigger: "blur" },
        ],
        Briefing: [{ required: true, message: "简介", trigger: "blur" }],
        Detail: [{ required: true, message: "详情", trigger: "blur" }],
        ListImg: [{ required: true, message: "图片", trigger: "blur" }],
        // IsStick: [{ required: true, message: "未选择", trigger: "blur" }],
        Status: [{ required: true, message: "未选择", trigger: "blur" }],
        CourseTypeId: [{ required: true, message: "未选择", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        Briefing: "",
        CourseTypeId: null,
        Name: "",
        Detail: "",
        IsStick: false,
        ListImg: "",
        Status: null,
        Istrue: null,
        Stroc: null,
      },
    };
  },
  methods: {
    selectGetlist() {
      this.page = 1;
      this.getLists();
    },
    closedFnShow() {
      this.$set(this, "isShowCodesStatus", false);
    },
    creatQrCode(value, type) {
      this.Codesvaluesigin = value;
      this.CodesvalueTypeSigin = type;
      this.$set(this, "isShowCodesStatus", true);
    },
    // 查看数据
    onLookDatas(id) {
      //this.$router.push('/Course/courseData_index')

      this.$router.push({
        path: "/Course/courseData_index",
        query: { Id: id },
      });
    },
    onEditorReady(editor) {},
    // 上传文件之前的钩子
    handleAvatarSuccess(res, file) {
      this.addForm.ListImg = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      if (
        !(
          file.type === "image/png" ||
          file.type === "image/gif" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg"
        )
      ) {
        this.$notify.warning({
          title: "警告",
          message:
            "请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片",
        });
      }
      let size = file.size / 1024 / 1024 / 2;
      if (size > 2) {
        this.$notify.warning({
          title: "警告",
          message: "图片大小必须小于2M",
        });
      }
    },
    // 上传文件
    uploadFile(item) {
      console.log(item);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("comId", this.comId);

      console.log(form);
      UploadImg(form).then((response) => {
        console.log("MediaAPI.upload");
        console.log(response);
        if (response.data.success) {
          this.addForm.ListImg = response.data.response;
          this.editForm.ListImg = response.data.response;
          console.log("filename", this.addForm.ListImg);
          this.$message.info("文件：" + fileObj.name + "上传成功");
        } else {
          this.$message.info("文件：" + fileObj.name + "上传失败");
        }
      });
    },
    //获取课程类型
    getcoursetypelist() {
      getcoursetypes({ CurriculumType: 1, Type: 1 }).then((res) => {
        console.log(res);
        this.coursetypelist = res.data.response;
        this.coursetypelist.reverse();
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters.name = item.search;
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatbcontent: function (row, column) {
      return row.bcontent ? row.bcontent.substring(20) : "N/A";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getLists();
    },
    getModules() {
      this.page = 1;
      console.log("getModules");
      this.getLists();
    },
    //获取列表
    getLists() {
      let para = {
        PageIndex: this.page,
        Title: this.filters.name,
        CourseTypeId: this.filters.CourseTypeId,
      };
      this.listLoading = true;
      getcourseListPage(para).then((res) => {
        if (res.data.success) {
          this.users = res.data.response.data;
          this.total = res.data.response.dataCount;
          this.listLoading = false;
          console.log(this.users);
        } else {
           this.users = [];
          this.total =0;
          this.listLoading = false;
        }
      });
    },
    //删除
    handleDel(id) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: id };
          coursedelete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getLists();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit(id, type) {
      console.log(type);
      if (type == 0) {
        this.editForm = {
          Id: null,
          CourseTypeId: null,
          Name: null,
          Detail: null,
          IsStick: false,
          ListImg: null,
          Status: null,
          Briefing: null,
          Istrue: null,
          Stroc: null,
          type: 2,
        };
        getcoursesingle({ CourseId: id }).then((res) => {
          if (res.data.success) {
            this.getcoursetypelist();
            this.editFormVisible = true;
            let editFormdata = res.data.response;
            console.log(editFormdata);
            this.editForm = {
              Id: editFormdata.Id,
              Briefing: editFormdata.Briefing,
              CourseTypeId: editFormdata.CourseTypeId,
              Name: editFormdata.Name,
              Detail: editFormdata.Detail,
              IsStick: false,
              ListImg: editFormdata.ListImg,
              Status: editFormdata.Status,
              Istrue: true,
              Stroc: editFormdata.Stroc,
              type: 2,
            };
             console.log(this.editForm);
            this.editForm.Istrue = true;
            this.$nextTick(() => {
              this.$refs["editForm"].clearValidate();
            });
          }
        });
        return;
      }
      if (type == 2) {
        (this.editForm = {
          Id: null,
          CourseTypeId: null,
          Name: null,
          Detail: null,
          IsStick: false,
          ListImg: null,
          Status: null,
          Briefing: null,
          Istrue: null,
          Stroc: null,
          type: 2,
        }),
          GetArticlesSingle({ id: id, types: 1 }).then((res) => {
            if (res.data.success) {
              this.getcoursetypelist();
              this.editFormVisible = true;
              let resdata = res.data.response;
              this.editForm.Istrue = false;
              console.log(resdata);
              this.editForm = {
                Id: resdata.Id,
                CourseTypeId: resdata.ArticleTypeId,
                Name: resdata.Title,
                Detail: resdata.Content,
                IsStick: false,
                ListImg: resdata.ListImg,
                Status: resdata.ArticleStatus,
                Briefing: resdata.Briefing,
                Istrue: false,
                Stroc: resdata.Stroc,
                type: 2,
              };
  console.log(this.editForm);
              this.$nextTick(() => {
                this.$refs["editForm"].clearValidate();
              });
            }
          });
        return;
      }
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Briefing: "",
        CourseTypeId: null,
        Name: "",
        Detail: "",
        IsStick: false,
        ListImg: "",
        Status: null,
      };

      this.$nextTick(() => {
        this.$refs["addForm"].clearValidate();
      });
      this.getcoursetypelist();
    },
    DialogDown() {
      this.addFormVisible = false;
      this.editFormVisible = false;
    },
    onOptionsyear() {
      if (this.addForm.Istrue == true) {
        return;
      }
      setTimeout(() => {
        this.Addwangeditor();
      }, 200);
    },
    Addwangeditor() {
      var c = document.getElementById("Add_container").innerHTML;
      console.log(c);
      if (c.length <= 0) {
        console.log("chua");
        this.editor = new E("#Add_container");
        //this.editor.customConfig.debug = true;
        this.editor.config.uploadImgServer = "/api/Img/UploadFiles";
        //this.editor.txt.html(this.editForm.Content);
        this.editor.create();
        console.log(this.editor.txt.html());
      }
      if (c != null) {
        this.editor.txt.html("");
      }
    },
    Editwangeditor() {
      if (this.editForm.Istrue == true) {
        return;
      }
      var c = document.getElementById("edit_container").innerHTML;
      //console.log(c);
      if (c == null || c.length <= 0) {
        console.log("chua");
        this.editor = new E("#edit_container");
        //this.editor.customConfig.debug = true;
        this.editor.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editor.txt.html(this.editForm.Detail);
        this.editor.create();
        console.log(this.editor.txt.html());
      }
      if (c != null) {
        this.editor.txt.html(this.editForm.Detail);
      }
    },
    //编辑
    editSubmit: function () {
      if (this.editor != null) {
        this.editForm.Detail = this.editor.txt.html();
      }
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            para.ModifyTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            console.log(para);
            ///课程
            if (this.editForm.Istrue) {
              backcourseupdate(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.getLists();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            } else {
              let ArticleeditForm = {
                Id: para.Id,
                Briefing: "",
                ArticleTypeId: para.CourseTypeId,
                Title: para.name,
                Content: para.Detail,
                IsStick: false,
                ListImg: para.ListImg,
                ArticleStatus: para.Status,
              };
              UpdateArticles(ArticleeditForm).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.getLists();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            }
          });
        }
      });
    },
    //新增
    addSubmit: function () {
       if (this.editor != null) {
      this.addForm.Detail = this.editor.txt.html();
       };
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.CreateTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            para.ModifyTime = para.CreateTime;
            var user = JSON.parse(window.localStorage.user);
            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addcourses(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getLists();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
    },
  },
  // computed: {
  //   editor() {
  //     return this.$refs.myQuillEditor.quill;
  //   },
  // },
  mounted() {
    this.getLists();

    this.getcoursetypelist();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
</style>
